import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { ClipboardService } from 'ngx-clipboard';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent implements OnInit {
  tenant: string;
  title: string;
  description: string;
  descriptionArray: any;
  descriptionArrayLength: number;
  defaultLinkTitle: string = translate('NOTIFICATIONS.VIEW_MORE');
  defaultLinkTitleLess: string = translate('NOTIFICATIONS.VIEW_LESS');
  copy: boolean;
  errorMessage: any;
  copyData: any;
  isErrorMessages = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private clipboardApi: ClipboardService,
  public matdialogRef: MatDialogRef<ErrorDialogComponent>,
  private sideNav: SidenavService, private authService: AuthService) {
    this.title = data.title;
    if(data?.description?.details?.length > 0) {
      this.descriptionArray = [];
      for (const errorMessage of data.description?.details){
        this.descriptionArray.push(errorMessage);
      }
      this.descriptionArrayLength = data.description?.details?.length;
    }
    if(data?.description?.errors?.length > 0) {
      this.descriptionArray = [];
      for (const errorMessage of data.description?.errors){
        this.descriptionArray.push(errorMessage);
      }
      this.descriptionArrayLength = data.description?.errors?.length;
    }
    else if (data?.description?.messages) {
      this.isErrorMessages = true;
      this.errorMessage = data.description.messages[0];
    } else if(data.description?.message){
      this.errorMessage = data.description.message;
    } else {
      if(data.description?.error?.details?.length > 0) {
        this.descriptionArray = [];
        for (const errorMessage of data.description?.error?.details){
          this.descriptionArray.push(errorMessage);
        }
        this.descriptionArrayLength = data.description?.error?.details?.length;
      }
      if (data.description?.error) {
        if(data.description?.error.message) {
          this.errorMessage = data.description?.error.message;
        } else if(data.description?.error?.code) {
          this.errorMessage = data.description?.error?.code;
        } else {
        this.errorMessage = data.description?.error;
        }
      } else if (data.description) {
        this.errorMessage = data.description;
      }
    }
    this.description = this.errorMessage;
    if(this.descriptionArray !== undefined) {
      this.descriptionArray = this.descriptionArray;
    }
  }

  ngOnInit(): void {
    this.copy = false;
    this.tenant = this.authService.principal.provider;
  }

  copyText(data): void {
    this.copyData = [];
    if(data.length > 0 && typeof data === 'object') {
      for (const description of data){
        this.copyData.push(description.message);
      }
    } else {
      this.copyData = data;
    }
    this.copy = true;
    this.clipboardApi.copyFromContent(this.copyData);
    setTimeout(() => {
      this.copy = false;
    }, 5000);
  }

  openContactForm(): void {
    this.matdialogRef.close(true);
    // this.sideNav.openInRightSidenav(ContactUsDialogComponent);
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

  toggleSelection(): void {
    this.matdialogRef.close(true);
  }

  onClick(): void {
    this.defaultLinkTitle =
      this.defaultLinkTitle ===
       translate('NOTIFICATIONS.VIEW_LESS') ? translate('NOTIFICATIONS.VIEW_MORE') : translate('NOTIFICATIONS.VIEW_LESS');
  }
}
